import { render, staticRenderFns } from "./GetProton.vue?vue&type=template&id=69a1d3a2&"
import script from "./GetProton.vue?vue&type=script&lang=js&"
export * from "./GetProton.vue?vue&type=script&lang=js&"
import style0 from "./GetProton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports